<template>
  <div class="overlay-inner-circle">
    <div class="spin"></div>
  </div>
</template>

<script>
export default {
  name: 'InnerCircle'
}
</script>

<style lang="scss" scoped>
.overlay-inner-circle {
  position: relative;
  pointer-events: none;
  display: block;
  width: 30px;
  height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  background-color: #2ac1bc;

  .spin {
    animation: spinAround 1s infinite linear;
    border-width: 3px;
    border-style: solid;
    border-radius: 50%;
    border-color: transparent transparent #fff #fff !important;
    display: block;
    height: 12px;
    width: 12px;
    position: absolute;
    left: 20%;
    top: 20%;
    content: '';
  }
}
</style>
